import { PaneSizeContext } from "./PaneSizeContext";
import { useContext } from "react";
import { SizeClass } from "./SizeClass";

export const usePaneWidth = (): SizeClass => {
  const size = useContext(PaneSizeContext);
  if (size === null)
    throw new Error("usePaneWidth can only be used inside a PaneSizeProvider");
  return size.width;
};
